import { translate } from '@/utils/translations'

const PlaceOrderButton = () => (
  <button className='vst-btn--large-full-width vst-btn--orange'>
    {translate('carts.place_order')}
  </button>
)

export default PlaceOrderButton
